export type CustomEntry = {
  category?: string
  custom?: boolean
  isHidden?: boolean
}

/**
 * Whether a category still offers its Custom log.
 *
 * The served Custom entry carries the category id, not an id of its own. An
 * absent entry counts as hidden: the only way it goes missing is the
 * `withCustom` request not landing, and offering an unfiltered Custom option is
 * the failure this is here to prevent.
 */
export const isCustomEntryVisible = (
  customEntries: ReadonlyArray<CustomEntry> | undefined,
  categoryId: string | undefined
): boolean => {
  if (!categoryId) return false

  const entry = customEntries?.find((item) => item?.category === categoryId)

  return entry !== undefined && entry.isHidden !== true
}

export type CategoryItem = {
  category?: string
  isHidden?: boolean
}

/**
 * Whether a category has anything a user could pick — any log still switched
 * on, or its Custom log.
 *
 * Custom counts: a Custom to-do is raised by choosing "+ Add Custom", so a
 * category left with only Custom is still usable rather than a dead end.
 */
export const categoryHasSelectableLog = (
  items: ReadonlyArray<CategoryItem> | undefined,
  customEntries: ReadonlyArray<CustomEntry> | undefined,
  categoryId: string | undefined
): boolean => {
  if (!categoryId) return false

  const anyVisibleItem = Boolean(
    items?.some(
      (item) => item?.category === categoryId && item.isHidden !== true
    )
  )

  return anyVisibleItem || isCustomEntryVisible(customEntries, categoryId)
}
